import { DIST_PRODUCT } from '@/enums/dist-products'
import { subscriptionTypes } from '@/modules/base/util/constants'
import isMSOfficeDocument from '@/modules/document/_helpers/isOfficeDocument'

const { product } = ENV

export const isAllowed = (document, subscriptions = null, { omo = ['L', 'XL'], mbo = ['L', 'XL'] } = {}) => {
  const isTaxConsultant = !!subscriptions?.filter((s) => s.isTaxConsultant === true)?.length

  if (isTaxConsultant || isMSOfficeDocument(document?.mimetype)) {
    return false
  }

  if (!subscriptions) {
    return true
  }

  const availableIn = [subscriptionTypes.DOCUMENT_TRIAL]
  if (product === DIST_PRODUCT.orgamax) {
    if (omo.includes('S')) availableIn.push(subscriptionTypes.DOCUMENT_S)
    if (omo.includes('M')) availableIn.push(subscriptionTypes.DOCUMENT_M)
    if (omo.includes('L')) availableIn.push(subscriptionTypes.DOCUMENT_L)
    if (omo.includes('XL')) availableIn.push(subscriptionTypes.DOCUMENT_L_ERP)
  } else {
    if (mbo.includes('S')) availableIn.push(subscriptionTypes.DOCUMENT_S)
    if (mbo.includes('M')) availableIn.push(subscriptionTypes.DOCUMENT_M)
    if (mbo.includes('L')) availableIn.push(subscriptionTypes.DOCUMENT_L)
    if (mbo.includes('XL')) availableIn.push(subscriptionTypes.DOCUMENT_XL)
  }

  return subscriptions.some((s) => availableIn.includes(s.subscriptionType))
}
